import { Component, Input, OnInit } from '@angular/core';
import { BaseWidgetComponent } from '../base-widget/base-widget.component';
import { IdentityService } from 'src/app/services/identity.service';

/**
 * Agents — the member's personal manager for ONE team (docs/plans/org-policy.md,
 * "Scope taxonomy + the Agents app", 2026-09-01).
 *
 * The primary noun is the Agent (Ben's ruling); credentials and the models they
 * unlock live here as the plumbing under the agents. Everything shown is
 * policy-curated for this team — in a locked-down org this page is nearly
 * empty, and that emptiness is honest communication about what the org lets
 * you own. The admin's control surface is the separate Team Policy app;
 * machine-level concerns (login, theme, …) stay in Settings.
 *
 * A team-scoped view at an address: openable per team from the palette, two
 * panels side by side for two teams. `teamName` comes from the widget inputs
 * (the venue), falling back to the identity's team for legacy opens.
 */
@Component({
  selector: 'app-agents-widget',
  templateUrl: './agents-widget.component.html',
  styleUrls: ['../base-widget/base-widget.component.scss', './agents-widget.component.scss'],
  standalone: false,
})
export class AgentsWidgetComponent extends BaseWidgetComponent implements OnInit {
  public title = 'Agents';

  constructor(private identity: IdentityService) {
    super();
  }

  get team(): string {
    return this.teamName || this.identity.me?.selectedTeamName || 'local';
  }

  ngOnInit(): void {
    this.title = `Agents · ${this.team}`;
  }
}
